/// <reference path="../setup/_references.ts" />
module onvio.firmDashboard {
    'use strict';

    angular.module('onvio.firmDashboard', [
        'onvio.firmDashboard.FirmDashboardController',
        'bm.core.dashboard.components.DashboardComponents'
    ]);
}
